export enum PublicFormType {
  Public = 0,
  Intranet = 1
}

export const PublicFormTypeLabels = {
  [PublicFormType.Public]: 'Public',
  [PublicFormType.Intranet]: 'Requires Sign in'
};
